import { render, staticRenderFns } from "./OperationsInTable.html?vue&type=template&id=764ed88c&scoped=true&"
import script from "./OperationsInTable.js?vue&type=script&lang=js&"
export * from "./OperationsInTable.js?vue&type=script&lang=js&"
import style0 from "./OperationsInTable.scss?vue&type=style&index=0&id=764ed88c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ed88c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
